// @ts-nocheck
import dayjs from "dayjs";
import {
  deletePositionAction,
  setSessionStep2FormAction,
  clearSessionStep2FormAction,
  clearSessionStep1DataAction,
  clearSessionData
} from "../../../../store/actions/createEvent";
import { dateRegex } from "../../../../utils/constants/dateRegex";
import { getTSeparatedDate } from "../../../../utils/methods/dateAndTimeMethods";
import { phoneNumberFormat } from "../../../../utils/methods/formatters";
import { isTimeTBD } from "../../../../appCalcutions";

const handleDeletePosition = ({
  id,
  data,
  eventInfo,
  dispatch,
  session,
  setDeleteId,
  successCallback,
  auth
}) => {
  setDeleteId ? setDeleteId(data?._id) : null;

  const payload = {
    positionId: data.positionId,
    id: data?._id
  };

  const afterSuccess = () => {
    // dispatch(getAllSessionsPositions(session?._id));
    // dispatch(getSessionssOfSpecificEvent(session?.eventId));
    // handleStepUp();
    successCallback ? successCallback() : null;
  };

  dispatch(
    deletePositionAction({
      sessionId: session?._id,
      position: data,
      eventInfo,
      payload,
      successCallback: afterSuccess,
      auth
    })
  );
};

const handleEditPosition = ({
  id,
  data,
  setEditId,
  setSearchTerm,
  dispatch,
  resetForm,
  setInitialValues
}) => {
  setEditId(id);

  const editInitialValues = {
    // position: positions.find((position) => position.positionName = data.positionName)?._id,
    positions: [
      {
        _id: data.positionId,
        positionName: data.positionName
      }
    ],
    // position: data.positionId,
    // positionName: data.positionName,
    dateStart: new Date(data.startDate)?.toISOString?.(),
    // dateStart: data?.startDate?.split?.("T")?.[0],
    timeIn: dateRegex.test(data.timeIn?.split?.("T")?.[0]) ? data?.timeIn : "",
    timeOut: dateRegex.test(data.timeOut?.split?.("T")?.[0])
      ? data?.timeOut
      : "",
    numberOfHours: data.numberOfHours || "",
    tbd: data?.numberOfHours > 0 ? true : false,
    quantity: data.quantity,
    complexity: data.complexity,
    option: data.selectOption,
    attire: data.attire,
    comments: data.additionalComments,
    PPE_Requirements: data.PPE_Requirements,
    overNightShift: data.overNightShift,
    id: data?._id
  };

  setSearchTerm(data.positionName);
  resetForm({
    values: editInitialValues
  });

  if (setInitialValues) {
    setInitialValues(editInitialValues);
  }

  dispatch
    ? dispatch?.(
        setSessionStep2FormAction({
          payload: {
            sessionStep2Form: editInitialValues
            // sessionStep2Form: null
          }
        })
      )
    : null;
};

const sessionObjToFormObjHandler = ({ session, eventInfo }) => {
  return {
    ...(session?._id ? { _id: session?._id } : {}),
    sessionName: session?.sessionName,
    sessionStart: session?.sessionStart,
    sessionEnd: session?.sessionEnd,
    sameLocAsEvent: session?.sameLocAsEvent,
    poNumber: session?.poNumber,
    sessionPoint: session?.sessionContactPoint,
    contact: phoneNumberFormat(session?.mobile),
    // location: session?.venue,
    venue: session?.venue || "",
    address1: session?.venueAddressLine1 || "",
    address2: session?.venueAddressLine2 || "",
    city: session?.venueCity || "",
    state: session?.venueState || "",
    zip: session?.venueZipCode || ""
  };
};

const clearSessionFormsHandler = ({ dispatch }) => {
  dispatch(clearSessionStep1DataAction());
  dispatch(clearSessionStep2FormAction({}));
  dispatch(clearSessionData());
};

const datesForDropDown = (start, end) => {
  // const sessionStart = setTimeToZero(new Date(start));
  const sessionStart = dayjs(start);
  // const sessionEnd = setTimeToZero(new Date(end));
  const sessionEnd = dayjs(end);

  const datesBetween = [];

  // let currentDate = new Date(sessionStart);
  let currentDate = dayjs(start);

  while (currentDate <= sessionEnd) {
    datesBetween.push(currentDate);
    currentDate = currentDate.add(1, "day"); // Increment currentDate by 1 day
  }

  return datesBetween;
};

const timeInAndTimeOutFromStartDate = (item, dateStart) => {
  if (isTimeTBD(item?.timeIn) || isTimeTBD(item?.timeOut))
    return { timeIn: "TBD", timeOut: "TBD" };
  if (
    item?.timeIn &&
    item?.timeOut &&
    new Date(dateStart)?.toString() !== "Invalid Date"
  ) {
    let hourTimeIn, minTimeIn, hourTimeOut, minTimeOut;
    const splittedTimeIn = item?.timeIn?.split?.("T")?.[1];
    const splittedTimeOut = item?.timeOut?.split?.("T")?.[1];
    // hour = timeDt?.getHours();
    // min = timeDt?.getMinutes();
    hourTimeIn = splittedTimeIn?.split?.(":")?.[0];
    minTimeIn = splittedTimeIn?.split?.(":")?.[1];

    hourTimeOut = splittedTimeOut?.split?.(":")?.[0];
    minTimeOut = splittedTimeOut?.split?.(":")?.[1];

    const dtTimeIn = dateStart ? dayjs(dateStart).toDate() : new Date();
    const dtTimeOut = dateStart
      ? item?.overNightShift
        ? dayjs(dayjs(dateStart).toDate()).add(1, "day").toDate()
        : dayjs(dateStart).toDate()
      : new Date();

    dtTimeIn?.setHours(hourTimeIn);
    dtTimeIn?.setMinutes(minTimeIn);

    dtTimeOut?.setHours(hourTimeOut);
    dtTimeOut?.setMinutes(minTimeOut);

    const formattedDtStrIn = getTSeparatedDate(dtTimeIn);
    const formattedDtStrOut = getTSeparatedDate(dtTimeOut);

    return {
      timeIn: formattedDtStrIn,
      timeOut: formattedDtStrOut
    };
  } else {
    return null;
  }
};

const overnightTimeOut = (item, isOvernight) => {
  if (
    item?.timeOut &&
    (dateRegex.test(item?.dateStart?.split?.("T")?.[0]) ||
      dateRegex.test(item?.startDate?.split?.("T")?.[0]))
  ) {
    let hourTimeIn, minTimeIn, hourTimeOut, minTimeOut;
    const splittedTimeOut = item?.timeOut?.split?.("T")?.[1];

    hourTimeOut = splittedTimeOut?.split?.(":")?.[0];
    minTimeOut = splittedTimeOut?.split?.(":")?.[1];

    const dateStartDt = dayjs(item?.dateStart || item?.startDate).toDate();

    if (isOvernight) {
      dateStartDt.setDate(dateStartDt.getDate() + 1);
    }

    const dtTimeOut =
      item?.dateStart || item?.startDate ? dateStartDt : new Date();

    dtTimeOut?.setHours(hourTimeOut);
    dtTimeOut?.setMinutes(minTimeOut);
    const formattedDtStrOut = getTSeparatedDate(dtTimeOut);

    return formattedDtStrOut;
  } else {
    return null;
  }
};

export {
  handleDeletePosition,
  handleEditPosition,
  sessionObjToFormObjHandler,
  clearSessionFormsHandler,
  datesForDropDown,
  timeInAndTimeOutFromStartDate,
  overnightTimeOut
};